
















































































































































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {
  Mall,
  GetInquiriesCountsRequest,
  GetCosBoardsBoardCodeSummaryResponse,
  BoardCode,
} from 'supporter';
import { addMonth, getStrDate, addDay, getStrYMDHMSS } from '@/utils/dateUtils';
import {getStorageByName} from '@/utils/excel';
import {namespace,Mutation} from 'vuex-class';
import CosMainBanner from './CosMainBanner.vue';
import ArticleTabList from './ArticleTabList.vue';
import ArticleNewBadge from './ArticleNewBadge.vue';
import { commerceApi } from '@/api';
import type { Admin } from '@/types';
import { getQuickMenus } from './utils';
import dayjs from 'dayjs';
import { stringify } from 'qs';
import '@ncds/ui-admin/dist/ui-admin/assets/styles/style.css';

const adminModule = namespace('admin');
const mallModule = namespace('mall');
const commerceMainUrl = process.env.VUE_APP_COMMERCE_MAIN;
const commerceSupportUrl = `${commerceMainUrl}/support/board`;
const commerceSellerTipUrl = `${commerceMainUrl}/main/class`;

@Component({
  components: {
    CosMainBanner,
    ArticleTabList,
    ArticleNewBadge
  },
})

export default class BottomMain extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  @Mutation('SET_DIMMEDAREASWITCH') private setDimmedAreaSwitch!: (flag: boolean) => void;
  @mallModule.State('malls') private stateMalls!: Mall[];
  @Prop({required: true}) private mainMall!: any;
  private taskMessageCountInProgress = 0;
  private oneByOneInqueries:any = {
    delayCount: '-',
    count: '-'
  };
  private productInquiryCount:any = {
    totalProductInquiryCountInLastMonth: '-',
    delayedReplyCountInLastMonth: '-'
  };
  private couponCount:any = {
    onCouponCnt: '-',
    couponCnt7DaysBeforeEnd: '-'
  };
  private additionalDiscounts:any = {
    additionalDiscountCnt7DaysBeforeEnd: '-',
    onAdditionalDiscountCnt: '-'
  };
  private eventSummary:any = {
    eventCountWillBeFinishedWithin3Days: '-',
    eventCount: '-'
  };
  private memberSummary:any = {
    numberOfWithdrawal: '-',
    numberOfSignUp: '-'
  };
  private noticeCategory = 'ALL';
  private noticeList: GetCosBoardsBoardCodeSummaryResponse = [];
  private upgradeList: GetCosBoardsBoardCodeSummaryResponse = [];
  private sellerTipList: GetCosBoardsBoardCodeSummaryResponse = [];
  private activeTab: 'ALL' | 'NOTICE' | 'UPDATE' = 'ALL';

  /**
   * 게시판 번호들은 알파/리얼 하드코딩으로 처리한다
   * 참고: https://nhnent.dooray.com/project/tasks/3849582055670506077#comment-4016236460470014273
   */
  private readonly CATEGORY_NO = {
    NOTICE_PRIMARY_NO: 34,
    NOTICE_COMMON_NO: 42,
    NOTICE_SHOPBY_NO: 37,
    UPDATE_PRIMARY_NO: 35,
    UPDATE_SHOPBY_NO: 40,
    SELLER_TIP_SHOPBY_NO: 81,
    API_UPDATE_SHOPBY_NO: Number(process.env.VUE_APP_API_UPDATE_SHOPBY_NO),
  }

  mounted() {
    this.search();
  }

  private get quickMenus() {
    return getQuickMenus(this.admin.plan);
  }

  @Watch('mainMall.no')
  onMainMallNoChanged() {
    this.search();
  }
  search() {
    this.setDimmedAreaSwitch(true);
    Promise.all([
      this.fetchProductInquiry(),
      this.fetchOneByOneInquiry(),
      this.fetchArticles(),
      this.fetchCoupon(),
      this.fetchEvents(),
      this.fetchMembers(),
    ])
    .finally(()=>{
      this.setDimmedAreaSwitch(false);
    })

  }
  fetchMembers() {
    if (this.mainMall.no) {
      const params = {
        mallNo: this.mainMall.no
      };
      this.$api.getMembersStates({params}).then((res) => {
        const {numberOfWithdrawal, numberOfSignUp} = res.data;
        this.memberSummary.numberOfWithdrawal = numberOfWithdrawal;
        this.memberSummary.numberOfSignUp = numberOfSignUp;
      });
    } else {
      this.$api.getMembersStates().then((res) => {
        const {numberOfWithdrawal, numberOfSignUp} = res.data;
        this.memberSummary.numberOfWithdrawal = numberOfWithdrawal;
        this.memberSummary.numberOfSignUp = numberOfSignUp;
      });
    }
  }
  fetchEvents() {
    if (this.mainMall.no) {
      const params = {
        mallNo: this.mainMall.no
      };
      this.$api.getEventsSummary({params}).then((res) => {
        const {eventCountWillBeFinishedWithin3Days, eventCount} = res.data;
        this.eventSummary.eventCountWillBeFinishedWithin3Days = eventCountWillBeFinishedWithin3Days;
        this.eventSummary.eventCount = eventCount;
      });
    } else {
      this.$api.getEventsSummary().then((res) => {
        const {eventCountWillBeFinishedWithin3Days, eventCount} = res.data;
        this.eventSummary.eventCountWillBeFinishedWithin3Days = eventCountWillBeFinishedWithin3Days;
        this.eventSummary.eventCount = eventCount;
      });
    }
  }
  fetchCoupon() {
    const mallNos = this.getMallNos();
    const onParams: any = {
      mallNos,
      statusType: 'ISSUE_ING',
      searchDateType: 'REGISTER_YMD',
      startYmd: addMonth(new Date(), -3),
      endYmd: getStrDate(new Date())
    };

    const endParams: any = {
      mallNos,
      statusType: 'ISSUE_ING',
      searchDateType: 'ISSUE_END_YMD',
      startYmd: getStrDate(new Date()),
      endYmd: addDay(new Date(), 7)
    };

    if (this.mainMall.no) {
      onParams.mallNos = this.mainMall.no;
      endParams.mallNos = this.mainMall.no;
    }
    this.$api.getTaskMessagesInProgress().then(({ data }) => this.taskMessageCountInProgress = data.taskMessageCountInProgress);
    this.$api.getCouponsCount({params: onParams}).then((res) => {
      this.couponCount.onCouponCnt = res.data.count;
    });
    this.$api.getCouponsCount({params: endParams}).then((res) => {
      this.couponCount.couponCnt7DaysBeforeEnd = res.data.count;
    });
    if (this.mainMall.no) {
      this.$api.getadditionalDiscountsSummary({params: {mallNo: this.mainMall.no}}).then((res) => {
        const {additionalDiscountCnt7DaysBeforeEnd, onAdditionalDiscountCnt} = res.data;
        this.additionalDiscounts.additionalDiscountCnt7DaysBeforeEnd = additionalDiscountCnt7DaysBeforeEnd;
        this.additionalDiscounts.onAdditionalDiscountCnt = onAdditionalDiscountCnt;
      });
    } else {
      this.$api.getadditionalDiscountsSummary().then((res) => {
        const {additionalDiscountCnt7DaysBeforeEnd, onAdditionalDiscountCnt} = res.data;
        this.additionalDiscounts.additionalDiscountCnt7DaysBeforeEnd = additionalDiscountCnt7DaysBeforeEnd;
        this.additionalDiscounts.onAdditionalDiscountCnt = onAdditionalDiscountCnt;
      });
    }
  }
  // 상품 문의
  fetchProductInquiry() {
    if (this.mainMall.no) {
      this.$api.getProductInquiriesSummary({params: {mallNo: this.mainMall.no}}).then((res) => {
        const {totalProductInquiryCountInLastMonth, delayedReplyCountInLastMonth} = res.data;
        this.productInquiryCount.totalProductInquiryCountInLastMonth = totalProductInquiryCountInLastMonth;
        this.productInquiryCount.delayedReplyCountInLastMonth = delayedReplyCountInLastMonth;
      });
    } else {
      this.$api.getProductInquiriesSummary().then((res) => {
        const {totalProductInquiryCountInLastMonth, delayedReplyCountInLastMonth} = res.data;
        this.productInquiryCount.totalProductInquiryCountInLastMonth = totalProductInquiryCountInLastMonth;
        this.productInquiryCount.delayedReplyCountInLastMonth = delayedReplyCountInLastMonth;
      });
    }
  }
  // 1:1 문의
  fetchOneByOneInquiry() {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);

    const params: GetInquiriesCountsRequest['params'] = {
      startDateTime: getStrYMDHMSS(date)
    };

    if (this.mainMall.no) {
      params.mallNos = this.mainMall.no;
    }

    this.$api.getInquiriesCounts({params}).then((res) => {
      const {issuedCount, inProgressCount, totalCount} = res.data;

      this.oneByOneInqueries.delayCount = issuedCount + inProgressCount;
      this.oneByOneInqueries.count = totalCount;
    });
  }
  imformationProtectGuide() {
    getStorageByName('service/shop by enterprise_개인정보보호 가이드.pdf', 'shop_by_enterprise_개인정보보호 가이드.pdf', 'guide');
    // const params = {container: 'guide', fileName: encodeURI('service/privacy_protect.pdf'), downloadName: encodeURI('NCP_개인정보보호_가이드.pdf')};
    // axios({
    //   headers: {
    //     Version: process.env.VUE_APP_STORAGE_API_VERSION
    //   },
    //   params,
    //   method: 'get',
    //   url: `${process.env.VUE_APP_STORAGE_API_URL}/storage`,
    //   responseType: 'blob'
    // }).then((ret: any) => {
    //   const myBlob = new window.Blob([ret.data], {type: 'blob'});
    //   const qrUrl = window.URL.createObjectURL(myBlob);
    //   const a = document.createElement('a');
    //   const event = new MouseEvent('click');
    //   a.download = 'NCP_개인정보보호_가이드.pdf';
    //   a.href = qrUrl;
    //   a.dispatchEvent(event);
    //   window.URL.revokeObjectURL(qrUrl);
    // });
  }
  getMallNos(): string {
    let mallNos = '';
    if (this.mainMall.no) {
      mallNos = '' + this.mainMall.no;
    } else {
      mallNos = this.stateMalls.map((mall) => mall.mallNo).toString();
    }
    return mallNos;
  }
  getNoticeCategoryLabel(noticeCategroy: string) {
    let label: any = 'ALL';
    switch (noticeCategroy) {
      case 'ALL':
        label = this.$t('NOTICE_CATEGORY_ALL');
        break;
      case 'GENERAL':
        label = this.$t('NOTICE_CATEGORY_GENERAL');
        break;
      case 'PROMOTION':
        label = this.$t('NOTICE_CATEGORY_PROMOTION');
        break;
      case 'WARNING':
        label = this.$t('NOTICE_CATEGORY_WARNING');
        break;
      case 'SAFETY_TRADE':
        label = this.$t('NOTICE_CATEGORY_SAFETY_TRADE');
        break;
      case 'SYSTEM':
        label = this.$t('NOTICE_CATEGORY_SYSTEM');
        break;
      default:
    }
    return label;
  }
  getYMD(ymdhms: string) {
    return ymdhms ? ymdhms.split(' ')[0] : '';
  }
  open(url: string) {
    window.open(url, '_blank');
  }
  private get bannerInfo() {
    return {
      src: new Date() <= new Date('2024-05-29 16:00:00') ? 'https://apps.nhn-commerce.com/apps/1119' : process.env.VUE_APP_WORKSPACE_URL,
      imageUrl: new Date() <= new Date('2024-05-29 16:00:00') ? require('@/assets/img/img-premium_admin_banner_chatbotnow.png') : require('@/assets/img/img-premium_admin_banner.png'),
      alt: 'shopby banner',
    };
  }

  private openCommerceBoard(primaryNo: number, secondaryNo: number) {
    window.open(
      `${commerceSupportUrl}?primaryCategoryNo=${primaryNo}&secondaryCategoryNo=${secondaryNo}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  private openArticleDetail(viewPath: string, url = commerceSupportUrl) {
    window.open(url + viewPath, '_blank', 'noopener,noreferrer');
  }

  private openSellerTipArticle(viewPath: string) {
    this.openArticleDetail(viewPath, commerceSellerTipUrl);
  }

  private async fetchArticles() {
    const { NOTICE_COMMON_NO, NOTICE_SHOPBY_NO, UPDATE_SHOPBY_NO, SELLER_TIP_SHOPBY_NO, API_UPDATE_SHOPBY_NO } = this.CATEGORY_NO;

    this.noticeList = await this.getArticles([NOTICE_COMMON_NO, NOTICE_SHOPBY_NO].join(','));
    this.upgradeList = await this.getArticles([UPDATE_SHOPBY_NO, API_UPDATE_SHOPBY_NO].join(','));
    this.sellerTipList = SELLER_TIP_SHOPBY_NO
      ? await this.getArticles(SELLER_TIP_SHOPBY_NO.toString(), 'COMMERCE_CLASS' as BoardCode)
      : [];
  }

  private get combinedArticles() {
    type Item = GetCosBoardsBoardCodeSummaryResponse[number] & { type: 'NOTICE' | 'UPDATE' };
    const noticeItems: Item[] = this.noticeList.map((item) => ({ ...item, type: 'NOTICE' as const }));
    const updateItems: Item[] = this.upgradeList.map((item) => ({ ...item, type: 'UPDATE' as const }));

    let merged: Item[];
    if (this.activeTab === 'NOTICE') {
      merged = noticeItems;
    } else if (this.activeTab === 'UPDATE') {
      merged = updateItems;
    } else {
      merged = [...noticeItems, ...updateItems].sort((a, b) =>
        b.publishedAt.localeCompare(a.publishedAt)
      );
    }

    return merged.slice(0, 7);
  }

  private get articleBoardLinks() {
    const { NOTICE_PRIMARY_NO, NOTICE_SHOPBY_NO, UPDATE_PRIMARY_NO, UPDATE_SHOPBY_NO } = this.CATEGORY_NO;
    return {
      news: `${commerceSupportUrl}?secondaryCategoryNo=0&primaryCategoryNo=0`,
      notice: `${commerceSupportUrl}?primaryCategoryNo=${NOTICE_PRIMARY_NO}&secondaryCategoryNo=${NOTICE_SHOPBY_NO}`,
      update: `${commerceSupportUrl}?primaryCategoryNo=${UPDATE_PRIMARY_NO}&secondaryCategoryNo=${UPDATE_SHOPBY_NO}`,
    };
  }

  private openCombinedBoard() {
    const { NOTICE_PRIMARY_NO, NOTICE_SHOPBY_NO, UPDATE_PRIMARY_NO, UPDATE_SHOPBY_NO } = this.CATEGORY_NO;
    if (this.activeTab === 'UPDATE') {
      this.openCommerceBoard(UPDATE_PRIMARY_NO, UPDATE_SHOPBY_NO);
    } else {
      this.openCommerceBoard(NOTICE_PRIMARY_NO, NOTICE_SHOPBY_NO);
    }
  }

  private get sellerTipBoardUrl() {
    return `${commerceSellerTipUrl}?categoryNo=${this.CATEGORY_NO.SELLER_TIP_SHOPBY_NO}`;
  }

  private openSellerTipBoard() {
    window.open(this.sellerTipBoardUrl, '_blank', 'noopener,noreferrer');
  }

  private async getArticles(categoryNos: string, boardCode: BoardCode = 'COMMERCE_NEWS') {
    const { data } = await commerceApi.getCosBoardsBoardCodeSummary({
      pathParams: {
        boardCode
      },
      params: {
        size: 7,
        categoryNos,
        isTopFixedFirst: true
      }
    });

    return data;
  }

  private getInquiryListUrl(isAll: boolean) {
    const inquiryStatuses = isAll ? ['ISSUED', 'IN_PROGRESS', 'ANSWERED'] : ['ISSUED', 'IN_PROGRESS'];
    const queryParams = {
      activeTab: 'list',
      params: JSON.stringify({
        inquiryStatuses,
        startDateTime: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        endDateTime: dayjs().format('YYYY-MM-DD'),
      }),
    };

    return `/inquiry/list?${stringify(queryParams)}`;
  }
}
